<template>
    <div
        v-if="!cmsView"
        class="p-2 mb-6 text-white bg-green-600 -mx-4"
    >
        <div class="container pt-2 px-2 mx-auto -px-4">
            <div class="flex space-x-2">
                <div class="flex items-center space-x-2">
                    <inertia-link
                        :href="route('landing')"
                        class="text-white"
                    >
                        Home
                    </inertia-link>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-chevron-compact-right"
                        viewBox="0 0 16 16"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671z"
                        />
                    </svg>
                </div>
                <div
                    v-for="(breadcrumb, index) in breadCrumbs"
                    :key="index"
                    class="flex items-center space-x-2"
                >
                    <inertia-link
                        v-if="breadcrumb.link"
                        :href="route(breadcrumb.link)"
                        class="line-clamp-1"
                    >
                        {{ breadcrumb.title }}
                    </inertia-link>
                    <div
                        v-else
                        class="line-clamp-1"
                    >
                        {{ breadcrumb.title }}
                    </div>

                    <svg
                        v-if="index !== breadCrumbs.length - 1"
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-chevron-compact-right"
                        viewBox="0 0 16 16"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671z"
                        />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            breadCrumbs: {
                type: Array,
                required: true,
            },
        },
    };
</script>
